import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { GetFrameworkCategories } from '../../queries/frameworks'
import { Query } from 'react-apollo'
import DataLoader from '../../app/DataLoader'
import LowLevelCategories from './components/LowLevelCategories'
import HighLevelCategories from './components/HighLevelCategories'
import { loader as Loader } from '../Loader'
import { signout } from '../../redux/actions/userActions'

class ProjectSummary extends React.Component {
  signoutUser () {
    this.props.signout()
    this.props.history.push('/')
  }

  render () {
    const { navigationStyle } = styles
    const highLevelCategory = this.props.match.params.highLevelCategory
    let sortedCategories = []

    return (
      <DataLoader>
        <div className="project-container">
          <Query
            query={GetFrameworkCategories()}
            fetchPolicy={'network-only'}
            variables={{ frameworkID: this.props.frameworkId }}
            onError={(e) => {
              if (e.networkError) {
                if (e.networkError['statusCode'] === 401) {
                  this.signoutUser()
                }
              } else {
                console.log(e.message)
                this.signoutUser()
              }
            }}
            onCompleted={(data) => {
            }}>
            {({ loading, error, data }) => {
              if (!loading && this.props.dataLoaded) {
                if (data && data.frameworkCategories) {
                  sortedCategories = data.frameworkCategories.categories.slice(0)

                  if (data.frameworkCategories.flat === true || highLevelCategory) {
                    return (<LowLevelCategories
                      loaded={!loading}
                      loading={loading}
                      navigationStyle={navigationStyle}
                      categories={sortedCategories}
                      flat={data.frameworkCategories.flat}
                      totalControls={
                        data.frameworkCategories.numberOfControls -
                        data.frameworkCategories.numberOfNotApplicableControls
                      }
                      compliantControlsTotal={0}
                      frameworkName={this.props.compliance}
                      headingDescription={this.props.description}
                      highLevelCategory={highLevelCategory}
                      urlFrameworkName={this.props.path}
                      frameworkId={this.props.frameworkId}
                      parse={this.props.parse}
                      layout={this.props.layout}
                    />)
                  } else {
                    try {
                      sortedCategories.sort((a, b) => {
                        if (a.highLevelOrder && b.highLevelOrder) {
                          return Number(a.highLevelOrder) - Number(b.highLevelOrder)
                        } else {
                          return 0
                        }
                      })
                    } catch (err) {
                    }

                    return (<HighLevelCategories
                      categories={sortedCategories}
                      frameworkName={this.props.compliance}
                      headingDescription={this.props.description}
                      urlFrameworkName={this.props.path}
                    />)
                  }
                }
              } else if (error) {
                console.log(`ERROR > ${error.message}`)
                return null
              } else {
                return <Loader />
              }
            }}
          </Query>
        </div>
      </DataLoader>
    )
  }
}

const styles = {
  navigationStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user,
    summary: state.controlsData.summary,
    dataLoaded: !state.controlsData.loading
  }
}

export default connect(mapStateToProps, { signout })(withRouter(ProjectSummary))



// WEBPACK FOOTER //
// ./src/components/compliance/ProjectSummary.js